import React, { useEffect, useState } from "react"
import Header from "../subsidiary/Header/Header"
import Loader from "../subsidiary/Loader/Loader"
import styles from "./Profile.module.css"
import arrow from '../../assets/img/shortArrow.svg'
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { getUserData } from './profileSlice'
import pusher from 'pusher-js';
import Echo from "laravel-echo";
import Modal from "./Modal";

const Profile = () => {
    const [modalVisible, setModalVisible] = useState(false)
    const navigation = useNavigate()
    const token = useSelector(state => state.loginSlice.token)
    const isLoaded = useSelector(state => state.loginSlice.isLoaded)
    const user = useSelector(state => state.profileSlice.user)

    const handleLogOut = () => {
        localStorage.removeItem('token')
        window.location.reload()
    }
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getUserData({ token }))
    }, [dispatch])


    return (
        <>
            {isLoaded && user ?
                <>
                    <section className="main">
                        <div className="content-wrapper">
                            <div className={styles.profileWrapper}>
                                <div style={{ paddingBottom: '10px' }} className="page-title-container">
                                    <div className="page-title ">
                                        <img className={styles.avatar} src={`${user?.avatar?.image}`} />
                                        <button className={styles.avatarPlus} onClick={() => setModalVisible(true)}>+</button>
                                    </div>
                                </div>
                                <div className="">
                                    <h1 className="page-title ">
                                        Добрый день,<br /> {user.name}
                                    </h1>
                                    <div onClick={() => { navigation('/settings/email') }} className={styles.settingItem}><div>{user.email}</div>  <img src={arrow} /></div>
                                    <div onClick={() => { navigation('/settings/phone') }} className={styles.settingItem}><div>{user.phoneNumber}</div>  <img src={arrow} /></div>
                                    <div onClick={() => { navigation('/settings/notification') }} className={styles.settingItem}><div>Настроить уведомления</div>  <img src={arrow} /></div>
                                    <div onClick={handleLogOut} className={styles.logOut}>Выйти из личного кабинета</div>
                                    {/* <div onClick={() => { navigation('/settings/password') }} className={styles.settingItem}><div>Изменить пароль</div>  <img src={arrow} /></div> */}
                                    <Modal visible={modalVisible} setVisible={setModalVisible}/>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
                : <Loader />}
        </>
    )
}
export default Profile
